<style lang="less">
    @import "../../../styles/table.less";
</style>
<template>
    <div class="search">
        <Row>
            <Col>
                <Card title="转换证明审核">
                    <Row @keydown.enter.native="handleSearch">
                        <Form ref="searchForm" :model="searchForm" inline :label-width="70">
                            <Form-item label="用户名" prop="userName">
                                <Input type="text" v-model="searchForm.userName" placeholder="请输入用户名称" clearable style="width: 200px"/>
                            </Form-item>
                            <Form-item label="类型" prop="sliderType">
                                <Select v-model="searchForm.auditState" placeholder="请选分类" clearable style="width: 200px">
                                    <Option :value="1">待审核</Option>
                                    <Option :value="2">转换成功</Option>
                                    <Option :value="3">转换失败</Option>
                                </Select>
                            </Form-item>
                            <Form-item label="是否使用" prop="isUse">
                                <Select v-model="searchForm.isUse" placeholder="请选择" clearable style="width: 200px">
                                    <Option :value=1>已使用</Option>
                                    <Option :value=0>未使用</Option>
                                </Select>
                            </Form-item>

                            <Form-item style="margin-left:-35px;" class="br">
                                <Button @click="handleSearch" type="primary" icon="ios-search">搜索</Button>
                                <Button @click="handleReset">重置</Button>
                                <a class="drop-down" @click="dropDown">{{dropDownContent}}
                                    <Icon :type="dropDownIcon"></Icon>
                                </a>
                            </Form-item>
                        </Form>
                    </Row>
                    <Row class="operation">
                        <Button @click="importFile" icon="md-add">导入转换证明</Button>
                        <Button @click="download" icon="md-arrow-round-down">下载模板</Button>
                        <Button @click="exportChange" icon="ios-share">导出申请记录</Button>
                        <Button @click="importUserRecord" icon="md-add">导入使用记录</Button>
                        <Button @click="downloadUserRecord" icon="md-arrow-round-down">下载使用记录模板</Button>
                        <circleLoading v-if="operationLoading"/>
                    </Row>
                    <Row>
                        <Table :loading="loading" border :columns="columns"  size="small"  :data="data" sortable="custom" @on-sort-change="changeSort" @on-selection-change="showSelect" ref="table"></Table>
                    </Row>
                    <Row type="flex" justify="end" class="page">
                        <Page :current="searchForm.pageNumber" :total="total" :page-size="searchForm.pageSize" @on-change="changePage" @on-page-size-change="changePageSize" :page-size-opts="[10,20,50]" size="small" show-total show-elevator show-sizer></Page>
                    </Row>
                </Card>
            </Col>
        </Row>
        <Upload action="/base/common/importProve" :on-success="handleSuccess"  v-show="false">
            <Button icon="ios-cloud-upload-outline" ref="upload">Upload files</Button>
        </Upload>
        <Upload action="/base/common/importUserRecord" :on-success="handleUserSuccess"  v-show="false">
            <Button icon="ios-cloud-upload-outline" ref="uploadUserRecord">Upload files</Button>
        </Upload>
        <change-drawer ref="changeDrawer"></change-drawer>
    </div>
</template>

<script>
    import circleLoading from "../../my-components/circle-loading.vue";
    import changeDrawer from "./change-drawer";
    import {changeList} from "@/api/bus";
    import Util from '@/libs/util';
    export default {
        name: "change-manage",
        components: {
            changeDrawer,
            circleLoading
        },
        data() {
            return {
                loading: false, // 表单加载状态
                operationLoading: false,
                drop: false,
                selectCount: 0, // 多选计数
                selectList: [], // 多选数据
                dropDownContent: "展开",
                dropDownIcon: "ios-arrow-down",
                searchForm: {
                    auditState: "",
                    isUse: 2, //是否使用
                    pageNumber: 1, // 当前页数
                    pageSize: 10, // 页面大小
                    sort: "c.createTime", // 默认排序字段
                    order: "desc", // 默认排序方式
                    courseTitle: "",
                    userName: "",
                    startDate: "",
                    endDate: ""
                },
                selectDate: null, //选择日期绑定modal
                columns: [
                    {
                        type: "index",
                        width: 60,
                        fixed: "left",
                        align: "center"
                    },
                    {
                        title: "用户名称",
                        fixed: "left",
                        align: "center",
                        width: 150,
                        key: "userName"
                    },
                    {
                        title: "身份证号",
                        key: "idCard",
                        align: "center",
                        width: 160
                    },
                    {
                        title: "国开学籍号",
                        key: "schoolNum",
                        align: "center",
                        width: 150
                    },
                    {
                        title: "审核状态",
                        key: "auditState",
                        align: "center",
                        width: 130,
                        render: (h, params) => {
                            if (params.row.auditState === '1') {
                                return h("div", [
                                    h(
                                        "Tag",
                                        {
                                            props: {
                                                color: "blue"
                                            }
                                        },
                                        "待审核"
                                    )
                                ]);
                            } else if(params.row.auditState === '2'){
                                return h("div", [
                                    h(
                                        "Tag",
                                        {
                                            props: {
                                                color: "green"
                                            }
                                        },
                                        "审核通过"
                                    )
                                ]);
                            } else {
                                return h("div", [
                                    h(
                                        "Tag",
                                        {
                                            props: {
                                                color: "red"
                                            }
                                        },
                                        "审核拒绝"
                                    )
                                ]);
                            }
                        }
                    },
                    {
                        title: "备注",
                        width: 150,
                        tooltip: true,
                        align: "center",
                        key: "reason",
                        render: (h, params) => {
                            if (params.row.reason) {
                                return h("div", params.row.reason);
                            } else {
                                return h("div", "--");
                            }
                        }
                    },
                    {
                        title: "转换证明有效期",
                        width: 150,
                        align: "center",
                        key: "validityTime",
                        render: (h, params) => {
                            if (params.row.validityTime) {
                                return h("div", params.row.validityTime);
                            } else {
                                return h("div", "--");
                            }
                        }
                    },
                    {
                        title: "是否使用",
                        key: "isUse",
                        align: "center",
                        width: 130,
                        render: (h, params) => {
                            if (params.row.isUse === 1) {
                                return h("div", [
                                    h(
                                        "Tag",
                                        {
                                            props: {
                                                color: "green"
                                            }
                                        },
                                        "已使用"
                                    )
                                ]);
                            } else if(params.row.isUse === 0) {
                                return h("div", [
                                    h(
                                        "Tag",
                                        {
                                            props: {
                                                color: "blue"
                                            }
                                        },
                                        "未使用"
                                    )
                                ]);
                            } else {
                                return h("div", "--");
                            }
                        }
                    },
                    {
                        title: "使用时间",
                        align: "center",
                        width: 150,
                        key: "useTime"
                    },
                    {
                        title: "手机号",
                        align: "center",
                        width: 150,
                        key: "mobile"
                    },
                    {
                        title: "持有证书",
                        tooltip: true,
                        width: 180,
                        align: "center",
                        key: "certificateName"
                    },
                    {
                        title: "证书编号",
                        width: 150,
                        align: "center",
                        key: "certificateNum"
                    },
                    {
                        title: "发证机构",
                        tooltip: true,
                        width: 150,
                        align: "center",
                        key: "award"
                    },
                    {
                        title: "颁证时间",
                        width: 150,
                        align: "center",
                        key: "cuTime"
                    },
                    {
                        title: "申请转换时间",
                        width: 150,
                        align: "center",
                        key: "createTime"
                    },
                    {
                        title: "操作",
                        key: "action",
                        fixed: "right",
                        width: 180,
                        align: "center",
                        render: (h, params) => {
                            return h("div", [
                                h(
                                    "Button",
                                    {
                                        props: {
                                            type: "primary",
                                            size: "small"
                                        },
                                        on: {
                                            click: () => {
                                                this.examine(params.row);
                                            }
                                        }
                                    },
                                    "审核"
                                )
                            ]);
                        }
                    }],
                data: [], // 表单数据
                total: 0 // 表单数据总数
            }
        },
        methods: {
            changeDropDown(row, v) {
                if (v == "transfercourse") {
                    this.transfercourse(row);
                }
                if (v == "condition") {
                    this.continuing(row);
                }
            },
            exportChange() {
                window.location.href = Util.initUrl("/base/common/exportChange", this.searchForm);
            },
            importFile() {
                this.$refs.upload.$el.click()
            },
            download() {
                location.href = "../转换证明.xlsx";
            },
            importUserRecord() {
                this.$refs.uploadUserRecord.$el.click()
            },
            downloadUserRecord() {
                location.href = "../使用记录.xlsx";
            },
            handleUserSuccess(response, file, fileList) {
                if(response.status){
                    this.$Message.success(response.info);
                    this.getDataList();
                }else{
                    this.$Message.error(response.info);
                }
            },
            init() {
                this.getDataList();
            },
            getDataList() {
                this.loading = true;
                changeList(this.searchForm).then(res => {
                    this.loading = false;
                    if (res.status === true) {
                        this.data = res.data.rows;
                        this.total = res.data.total;
                    }
                });
            },
            getDataList2() {
                this.loading = true;
                changeList().then(res => {
                    this.loading = false;
                    if (res.status === true) {
                        this.data = res.data.rows;
                        this.total = res.data.total;
                    }
                });
            },
            examine(v) {
                if(v.auditState != '1'){
                    this.$Message.error("该记录已审核");
                    return;
                }
                let query = {id: v.id, sysUsercertificateId: v.sysUsercertificateId};
                this.$refs.changeDrawer.showDrawer(query);
            },
            //设置课程推荐状态
            handleSearch() {
                console.info(this.searchForm)
                this.searchForm.pageNumber = 1;
                this.searchForm.pageSize = 10;
                this.getDataList();
            },
            handleSuccess(response, file, fileList) {
                if(response.status){
                    this.$Message.success(response.info);
                    this.getDataList();
                }else{
                    this.$Message.error(response.info);
                }
            },
            handleReset() {
                console.info(this.searchForm)
                this.searchForm.isUse = 2;
                this.searchForm.pageNumber = 1;
                this.searchForm.pageSize = 10;
                this.selectDate = null;
                this.searchForm.startDate = "";
                this.searchForm.endDate = "";
                this.searchForm.auditState = "";
                this.searchForm.userName = "";
                // 重新加载数据
                this.getDataList2();
            },
            dropDown() {
                if (this.drop) {
                    this.dropDownContent = "展开";
                    this.dropDownIcon = "ios-arrow-down";
                } else {
                    this.dropDownContent = "收起";
                    this.dropDownIcon = "ios-arrow-up";
                }
                this.drop = !this.drop;
            },
            selectDateRange(v) {
                if (v) {
                    this.searchForm.startDate = v[0];
                    this.searchForm.endDate = v[1];
                }
            },
            changePage(v) {
                this.searchForm.pageNumber = v;
                this.getDataList();
                this.clearSelectAll();
            },
            changePageSize(v) {
                this.searchForm.pageSize = v;
                this.getDataList();
            },
            changeSort(e) {
                this.searchForm.sort = e.key;
                this.searchForm.order = e.order;
                if (e.order === "normal") {
                    this.searchForm.order = "";
                }
                this.getDataList();
            },
            showSelect(e) {
                this.selectList = e;
                this.selectCount = e.length;
            },
            clearSelectAll() {
                this.$refs.table.selectAll(false);
            },
        },
        mounted() {
            this.init();
        }
    }
</script>
